module.exports = __webpack_public_path__ + "img/curtainClose.56e1c91a.svg";